import { render, staticRenderFns } from "./AccountProjectAssignedNotification.vue?vue&type=template&id=adc9d4aa"
import script from "./AccountProjectAssignedNotification.vue?vue&type=script&lang=js"
export * from "./AccountProjectAssignedNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports